export default "__VITE_ASSET__7bb6c510__"